import IWorkOrderViewModel from "interfaces/IWorkOrderViewModel";
import IGetWorkOrderWorkOrderViewModel from "interfaces/Response/IGetWorkOrderWorkOrderViewModel";
import { WorkOrderStatusEnum } from "modules/WorkOrderStatusEnum";

function mapWorkOrderResponseToWorkOrderViewModel(
  workOrder: IGetWorkOrderWorkOrderViewModel
): IWorkOrderViewModel {
  const workOrderViewModel: IWorkOrderViewModel = {
    workOrderReference: workOrder.workOrderReference,
    slaStart: new Date(workOrder.slaStart),
    slaTime: workOrder.slaTime,
    slaEnd: new Date(workOrder.slaEnd),
    status: workOrder.status! as WorkOrderStatusEnum,
    lastUpdatedTimestamp: new Date(workOrder.lastUpdatedTimestamp),
    regionId: workOrder.regionId,
    regionName: workOrder.regionName,
    hwrcSiteName: workOrder.hwrcSiteName,
    disposalSiteId: workOrder.disposalSiteId,
    disposalSiteName: workOrder.disposalSiteName,
    raisedBy: workOrder.raisedBy,
    raisedByTimestamp: workOrder.raisedByTimestamp ? new Date(workOrder.raisedByTimestamp) : undefined,
    comments: workOrder.comments,
    nonCollectionReason: workOrder.nonCollectionReason,
    nonDisposalReason: workOrder.nonDisposalReason,
    updateReason: workOrder.updateReason,
    completionReason: workOrder.completionReason,
    tempDropHwrcSiteName: workOrder.tempDropLocation?.name,
    tempDropRegionName: workOrder.tempDropLocation?.regionName,
    collectorId: workOrder.collector.id,
    collectorIsVehicle: workOrder.collector.isVehicle,
    collectorName: workOrder.collector.collectorName,
    collectorType: workOrder.collector.collectorType,
    containerId: workOrder.container.id!,
    containerName: workOrder.container.name!,
    containerWasteTypeId: workOrder.container.wasteTypeId!,
    containerWasteType: workOrder.container.wasteType!,
    containerAboveThreshold: workOrder.container.aboveThreshold!,
    containerSize: workOrder.container.size!
  };

  return workOrderViewModel;
}

export { mapWorkOrderResponseToWorkOrderViewModel };
